export const hasProductionCompany = (list, productionCompany) => {
    return list.filter(c => c === productionCompany)
        .length > 0;
};

export const hasProject = (list, projectId) => {
    return list.filter(p => p === projectId).length > 0;
};
